import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const ProcessingPersonality = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Wait 3 seconds, then navigate to the results page
    const timer = setTimeout(() => {
      navigate('/personality-result');
    }, 3000);

    return () => clearTimeout(timer); // Cleanup in case component unmounts
  }, [navigate]);

  return (
    <div className="min-h-screen flex flex-col justify-center items-center" style={{ backgroundColor: '#0D2329' }}>
      
      {/* Logo Image */}
      <img 
        src="/p-logo.png" // Replace with actual path
        alt="Logo"
        className="mb-1 w-35 h-35"
      />

      {/* Primary Text */}
      <h1 className="text-white text-4xl font-bold text-center mb-3">
        Calculating <br /> Your Personality Trait....
      </h1>

      {/* Secondary Text */}
      <p className="text-white text-lg text-center mb-6">
        We are determining your best possible <br /> personality trait based on your answer!
      </p>

      {/* Spinning Loading Animation */}
      <img 
        src="/puzzle.png" // Replace with actual path
        alt="Loading"
        className="w-16 h-16 animate-spin"
      />
    </div>
  );
};

export default ProcessingPersonality;
